import * as React from 'react'

import { Alert } from '@grandvisionhq/common'
import { DateOfBirthSelect, Email, FormGroup, PhoneNumber, Text } from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

import { FormProps } from '../types'
import { isIbanValid, isValidPhoneNumber } from '~/components/validators'

function isDashedYYYYMMDD(value: string): boolean {
  /**
   * Any date after 1900-01-01 in the YYYY-MM-DD format.
   */
  return /^(19|[2-9][0-9])\d{2}-\d{1,2}-\d{1,2}$/.test(value)
}

const ContactDetailsForm: React.FC<FormProps> = ({
  cartContainsPrescriptionGlasses,
  cartContainsSubscription,
}) => {
  const { getLabel } = useIntl()

  return (
    <React.Fragment>
      <DateOfBirthSelect
        name="customerDOB"
        required
        validations={[isDashedYYYYMMDD]}
        errorMessage={getLabel('checkout.contact.dateofbirth.error')}
        label={getLabel('checkout.contact.dateofbirth')}
        tooltipLabel={getLabel('checkout.contact.dateofbirth.tooltip')}
        dayPlaceholder={getLabel('checkout.contact.dateofbirth.day.placeholder')}
        monthPlaceholder={getLabel('checkout.contact.dateofbirth.month.placeholder')}
        yearPlaceholder={getLabel('checkout.contact.dateofbirth.year.placeholder')}
      />
      <FormGroup>
        <PhoneNumber
          required={cartContainsPrescriptionGlasses}
          label={getLabel('checkout.contact.phoneNumber')}
          validations={[isValidPhoneNumber]}
          errorMessage={getLabel('checkout.contact.phoneNumber.errorMessage')}
          optionalText={
            cartContainsPrescriptionGlasses ? '' : getLabel('checkout.form.field.optional')
          }
        />
        <Email
          label={getLabel('checkout.contact.email')}
          errorMessage={getLabel('checkout.contact.email.errorMessage')}
        />
      </FormGroup>
      {cartContainsSubscription && (
        <FormGroup className="checkout-step__iban">
          <Alert
            title={getLabel('checkout.ibanNumber')}
            message={getLabel('checkout.iBanConsent')}
          />
          <Text id="secretIBAN" label="IBAN" data-t="Iban" validations={[isIbanValid]} />
        </FormGroup>
      )}
    </React.Fragment>
  )
}

export default ContactDetailsForm
